import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
    FormControl,
    InputLabel,
    Select, MenuItem, CircularProgress
} from "@material-ui/core";
import * as Yup from "yup";
import {hasPermission} from "../../sc-utilities";
import {updateKey} from "../TypicalProblem/TypicalProblemForm";

const styles = theme => ({
    root: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    }
});

export const types = [{value: "system", displayValue: "System operating system"}, {value: "custom", displayValue: "Customer operating system"}];

const OperatingSystemForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations,  permissions, CustomerIDPreviousState, fromEdit } = props;

    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit, setFieldValue } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={(e) => {handleChange(e); setFieldValue('Key', e.target.value)}}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["short_name"] || "Short name"}
                                label={translations["short_name"] || "Short name"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="LongName"
                                value={values.LongName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.LongName && touched.LongName)}
                                placeholder={translations["long_name"] || "Long name"}
                                label={translations["long_name"] || "Long name"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            {hasPermission(permissions, 'system_operating_system_create') ? (<><FormControl className={classes.formControl}
                                                                                                           margin={"dense"}>
                                <InputLabel
                                    shrink>{translations['operating_system_type'] || "Please select operating system type"}</InputLabel>
                                <Select
                                    name="CustomerID"
                                    label={translations['operating_system_type'] || 'Please select operating system type'}
                                    margin={"dense"}
                                    value={values?.CustomerID?.toString() || ''}
                                    onChange={handleChange}
                                    disabled={values?.CustomerID?.toString() === 'system' && fromEdit && CustomerIDPreviousState==='system'}
                                >
                                    {(types ? [...types] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value.toString()}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                                {values?.CustomerID?.toString() === 'system'  ? <TextField
                                    name="Key"
                                    value={values?.Key ? updateKey(values?.Key) : ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.Key)}
                                    placeholder={translations['operating_system_key'] || 'Key'}
                                    label={translations['operating_system_key'] || 'Key'}
                                    margin={"dense"}
                                    fullWidth={true}
                                /> : null}
                            </>) : null}
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {isSubmitting ? <CircularProgress size={24}/> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(OperatingSystemForm);
